import { render, staticRenderFns } from "./StagingRelatedDocsSectionEditor.vue?vue&type=template&id=f333e894"
import script from "./StagingRelatedDocsSectionEditor.vue?vue&type=script&lang=ts"
export * from "./StagingRelatedDocsSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./StagingRelatedDocsSectionEditor.vue?vue&type=style&index=0&id=f333e894&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports